<template>
    <div class="navigation">
        <img v-if="canBack" :src="back" class="back" @click="clickBack">
        <div v-if="canZoom" class="zoom">
            <img  :src="zoomImage" class="zoom-btn" @click="clickZoom" ref='zoom'>
        </div>
        <div class="transition" ref="transition"></div>
    </div>
</template>

<style scoped>
    .navigation {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 6;
        display: grid;
        grid-template-columns: 12.5% 65% 20.5%;
        grid-template-rows: 12.5% 75% 12.5%;
        width : 100vw;
        height : 100%;
        padding: 5px;
        pointer-events: none;
    }

    .transition {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height : 100vh;
        z-index: 6;
        background-color: white;
    }

    .back {
        border: none;
        width : 100%;
        height : 100%;
        max-width: 45px;
        max-height: 45px;
        min-width: 35px;
        /* height : 75px; */
        color: white;
        font-weight: bold;
        pointer-events: all;
    }

    .zoom {
        position: relative;
        width: 100%;
        height: 100%;
        grid-column: 3;
        grid-row: 3;
    }
    .zoom-btn {
        position: absolute;
        bottom: 0;
        right : 0;
        border: none;
        width : 100%;
        height : 100%;
        max-width: 45px;
        max-height: 45px;
        min-width: 35px;
        padding: 0 0 0 0;
        /* height : 75px; */
        
        color: white;
        font-weight: bold;
        pointer-events: all;
    }
</style>

<script>

import backImage from "@/assets/images/icons/btn_back.svg";
import zoomInImage from "@/assets/images/icons/btn_zoom_in.svg";
import zoomOutImage from "@/assets/images/icons/btn_zoom_out.svg";
import {gsap} from "gsap";


export default {
    data : function() {
        return {
            back : backImage,
            zoomImage :  zoomInImage,
            zoomState : 'in',
            canZoom : false,
            timeline : new gsap.timeline()
        }
    },

    computed : {
        enterGallery() { return this.$store.state.enterGallery },
        startRoom() { return this.$store.state.startRoom},
        transition() { return this.$store.state.transition},
        canBack() { return this.$store.state.screens.splash.active == false }

    },

    watch : {
        startRoom() { this.canZoom = true;},
        enterGallery() { this.canZoom = false},
        transition(transition) {
            if(transition == 'in') { 
                this.transitionIn();
            }

            if(transition == 'out'){
                this.transitionOut();
            }
        }
    },

    methods : {
        //Crack shoot
        clickBack : function(){
            this.$store.commit('clickBack');
        },
        
        clickZoom : function(){
            this.$store.commit(this.zoomState == 'in' ? 'zoomIn' :  'zoomOut');

            this.zoomState = this.zoomState == 'in' ? 'out' : 'in';
            this.$refs.zoom.src = this.zoomState == 'in' ? zoomInImage : zoomOutImage;
        },

        transitionOut(){
            let elm = this.$refs.transition;
            elm.style.display = 'block';
            this.$store.commit('startTransition')
            this.timeline.clear();
            this.timeline.set(elm, {autoAlpha : 0});
            this.timeline.to(elm, 0.5, {autoAlpha : 1, onComplete : ()=>{
                this.$store.commit('endTransition')
            }
            })
        },

        transitionIn(){
            let elm = this.$refs.transition;
            this.$store.commit('startTransition')
            this.timeline.clear();
            this.timeline.to(elm, 0.5, {autoAlpha : 0, onComplete : ()=> {
                this.$store.commit('endTransition');
                elm.style.display = 'none';
            } })
        }
        
    }
}
</script>